function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_605_9)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.333333 0C0.244928 0 0.160143 0.035119 0.0976311 0.0976311C0.035119 0.160143 0 0.244928 0 0.333333L0 7.66667C0 7.75507 0.035119 7.83986 0.0976311 7.90237C0.160143 7.96488 0.244928 8 0.333333 8H1.66667V9.66667C1.66666 9.73039 1.68492 9.79278 1.71928 9.84644C1.75365 9.9001 1.80267 9.94279 1.86055 9.96945C1.91842 9.99611 1.98273 10.0056 2.04585 9.99685C2.10896 9.98809 2.16824 9.96142 2.21667 9.92L4.45667 8H7.66667C7.71047 8.00008 7.75386 7.99152 7.79435 7.97482C7.83485 7.95812 7.87165 7.9336 7.90267 7.90267L9.90267 5.90267C9.9336 5.87165 9.95812 5.83485 9.97482 5.79435C9.99152 5.75386 10.0001 5.71047 10 5.66667V0.333333C10 0.244928 9.96488 0.160143 9.90237 0.0976311C9.83986 0.035119 9.75507 0 9.66667 0L0.333333 0ZM6.66667 5.33333V2H7.33333V5.33333H6.66667ZM4.66667 2V5.33333H5.33333V2H4.66667Z",
  fill: "#EEEEEE"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_605_9"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 10,
  fill: "white"
})));

function SvgIcoTwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTwitch);
export default __webpack_public_path__ + "static/media/ico_twitch.fabb694a.svg";
export { ForwardRef as ReactComponent };